/**
 * GENERATED FILE — DO NOT EDIT.
 *
 * Generated from the markdown sources in `legal/` by `tools/build-legal-docs.mjs`.
 * To change a document or bump a version, edit `legal/` and run `pnpm legal:build`.
 */

export interface IMarkdownDocumentConfig {
    /** Document version (YYYY.MM[.n]); bumping the EULA version forces re-acceptance. */
    version: string;
    /** ISO date the version takes effect. */
    effectiveDate: string;
    /** Locales the document is available in ('en' is always present). */
    locales: string[];
    /** Per-locale document title. */
    titles: Record<string, string>;
}

export interface IEifuDocumentConfig extends IMarkdownDocumentConfig {
    /** Document issue date printed on the eIFU. */
    issueDate: string;
    /** Software release this IFU corresponds to. */
    softwareVersion: string;
}

export interface IDocumentOfConformityConfig {
    version: string;
    effectiveDate: string;
    /** Device version(s) covered by the signed declaration. */
    deviceVersion: string;
    /** File name of the signed PDF under public/legal/doc/. */
    file: string;
}

export interface ILegalDocumentsConfig {
    eula: IMarkdownDocumentConfig;
    privacyPolicy: IMarkdownDocumentConfig;
    legalNotice: IMarkdownDocumentConfig;
    eifu: IEifuDocumentConfig;
    professionalAttestation: IMarkdownDocumentConfig;
    dpa: IMarkdownDocumentConfig;
    baa: IMarkdownDocumentConfig;
    doc: IDocumentOfConformityConfig;
}

export const LEGAL_DOCUMENTS: ILegalDocumentsConfig = {
    eula: {
        version: '2026.07',
        effectiveDate: '2026-07-15',
        locales: ['en'],
        titles: {
            en: 'End-User Licence Agreement',
        },
    },
    privacyPolicy: {
        version: '2026.07',
        effectiveDate: '2026-07-15',
        locales: ['en'],
        titles: {
            en: 'Privacy Policy',
        },
    },
    legalNotice: {
        version: '2026.07',
        effectiveDate: '2026-07-15',
        locales: ['en'],
        titles: {
            en: 'Legal Notice',
        },
    },
    eifu: {
        version: '2026.07',
        effectiveDate: '2026-07-15',
        locales: ['en'],
        titles: {
            en: 'ESCloud — Instructions for Use',
        },
        issueDate: '2026-07-15',
        softwareVersion: '0.0.1',
    },
    professionalAttestation: {
        version: '2026.08',
        effectiveDate: '2026-08-05',
        locales: ['en'],
        titles: {
            en: 'Professional Qualification Attestation',
        },
    },
    dpa: {
        version: '2026.08',
        effectiveDate: '2026-08-05',
        locales: ['en'],
        titles: {
            en: 'Data Processing Agreement',
        },
    },
    baa: {
        version: '2026.08',
        effectiveDate: '2026-08-05',
        locales: ['en'],
        titles: {
            en: 'Business Associate Agreement',
        },
    },
    doc: {
        version: '2026.07',
        effectiveDate: '2026-07-15',
        deviceVersion: '0.0.1',
        file: 'escloud-doc-2026.07.pdf',
    },
};
